import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Radio from "@material-ui/core/Radio";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import currency from "../../../../utils/currency";
import { duration } from "../../../../utils/duration";
import { DialogContent } from "@material-ui/core";

function DialogKurir({ openKurir, closeKurir, changeKurir, data, oldId }) {
  return (
    <Dialog
      open={openKurir}
      onClose={closeKurir}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ArrowBackIcon style={{ cursor: "pointer" }} onClick={closeKurir} />
          <Typography
            style={{ fontWeight: "bold", marginLeft: "20px", fontSize: "20px" }}
          >
            Pilih Kurir
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{padding:10}}>
        {data.map((item, index) => {
          return (
            <List
              key={index}
              subheader={
                <ListSubheader disableSticky={true}>{item.title}</ListSubheader>
              }
            >
              {item?.data?.map((kurir, idx) => {
                return (
                  <ListItem
                    key={idx}
                    button
                    onClick={async () =>
                      changeKurir({ ...kurir, type: item?.title })
                    }
                  >
                    <ListItemAvatar>
                      <Avatar
                        variant="square"
                        src={kurir?.logo_url}
                        style={{ height: "auto" }}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={`${kurir?.name} - ${kurir?.rate_name}`}
                      secondary={
                        kurir?.discount > 0 ? (
                          <>
                            <div style={{ display: "flex" }}>
                              <Typography
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                                component="p"
                              >
                                {currency(kurir?.finalRate - kurir?.discount)}{" "}
                              </Typography>
                              <Typography
                                // color="secondary"
                                style={{
                                  textDecoration: "line-through",
                                  color: "grey",
                                  fontSize: "12px",
                                  marginRight: "5px",
                                  marginLeft: "5px",
                                }}
                                component="p"
                              >
                                {currency(kurir?.finalRate)}
                              </Typography>
                            </div>
                            <Typography
                              style={{
                                color: "black",
                              }}
                              component="p"
                            >
                              {duration(kurir?.min_day, kurir?.max_day)}
                            </Typography>
                          </>
                        ) : (
                          <Typography component="p">
                            {currency(kurir?.finalRate)}{" "}
                            {duration(kurir?.min_day, kurir?.max_day)}
                          </Typography>
                        )
                      }
                    />
                    <ListItemSecondaryAction>
                      <Radio
                        color="primary"
                        checked={oldId === kurir?.rate_id}
                        onClick={async () =>
                          changeKurir({ ...kurir, type: item?.title })
                        }
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          );
        })}
      </DialogContent>
    </Dialog>
  );
}

export default DialogKurir;
